import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom'

const SettingWrapper = () => {
  const location = useLocation()
  return (
        <div className='card mb-5 mb-xl-10'>
          <div className='card-body pb-0 pt-2'>
            <div className='d-flex overflow-auto h-55px'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                {/* Begin: Subscription link */}
                <li className='nav-item'>
                  <Link
                    className={
                      `nav-link text-active-primary me-6 ` +
                      (location.pathname === `/user-settings/subscription` && 'active')
                    }
                    to='subscription'
                  >
                    Subscription
                  </Link>
                </li>
                {/* End: Subscription link */}
              </ul>
            </div>
          </div>
        </div>
  )
}

export default SettingWrapper
